import "../../../../design/developer.css";

export default function Developer() {
    return (
        <div className="footerDeveloperSpace">
            {/* Left Side: Copyright */}
            <div className="footer-legal-links">
                <span>&copy; {new Date().getFullYear()} Teacher Hub. ყველა უფლება დაცულია.</span>
            </div>

            {/* Right Side: Developer Link */}
            <div className="developer-credit">
                <a
                    href="https://otarmurmanishvili.netlify.app"
                    target="_blank"
                    rel="noreferrer"
                    className="developer-box"
                >
                    Developer - Otar Murmanishvili
                </a>
            </div>
        </div>
    );
}